<span *ngIf="data.name">{{ data.name }}</span>
<ng-container *ngIf="data.lastAuthor && data.lastChange">
    <br /><span
        >{{ "APP._Variation.CostDiffIndicators.Author" | lgTranslate }}:
        {{ data.lastChange | date: "dd/MM/yyyy" }}</span
    >
    <br /><span>{{ data.lastAuthor }}</span>
</ng-container>
<ng-container *ngIf="data.text">
    <br /><br /><span>{{ data.text }}</span>
</ng-container>
